import PropTypes from "prop-types";
import {
  Box,
  TableRow,
  TableCell,
  TableHead,
  TableSortLabel,
} from "@mui/material";

const visuallyHidden = {
  border: 0,
  margin: -1,
  padding: 0,
  width: "1px",
  height: "1px",
  overflow: "hidden",
  position: "absolute",
  whiteSpace: "nowrap",
  clip: "rect(0 0 0 0)",
};

TableHeader.propTypes = {
  order: PropTypes.oneOf(["asc", "desc"]),
  orderBy: PropTypes.string,
  columnDefinition: PropTypes.array,
  rowCount: PropTypes.number,
  numSelected: PropTypes.number,
  onSort: PropTypes.func,
  onSelectAll: PropTypes.func,
  sortableColumns: PropTypes.array,
};

export default function TableHeader({
  order,
  orderBy,
  columnDefinition,
  rowCount,
  numSelected,
  onSort,
  onSelectAll,
  sortableColumns,
}: any) {
  const createSortHandler = (property: any) => (event: any) => {
    onSort(event, property);
  };

  return (
    <TableHead>
      <TableRow style={{ paddingLeft: "24px", backgroundColor: "red" }}>
        {columnDefinition.map((col: any, index: any) => {
          const isSortable = sortableColumns.includes(col.key);
          const isFirstColumn = index === 0;
          return (
            <TableCell
              style={isFirstColumn ? { paddingLeft: "24px" } : {}}
              key={index}
              align={col.align}
              sortDirection={orderBy === col.key ? order : false}
            >
              {isSortable ? (
                <TableSortLabel
                  hideSortIcon
                  active={orderBy === col.key}
                  direction={orderBy === col.key ? order : "asc"}
                  onClick={createSortHandler(col.key)}
                >
                  {col.label}
                  {orderBy === col.key ? (
                    <Box sx={{ ...visuallyHidden }}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </Box>
                  ) : null}
                </TableSortLabel>
              ) : (
                col.label
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}
